<template>
    <Password v-model="model"
              :feedback="feedback"
              toggleMask
              ref="passwordinput"
              autocomplete="off"
    >
        <template #maskicon>
            <IMDI icon="eye"
                  @click="() => passwordinput.unmasked = !passwordinput.unmasked"
            />
        </template>
        <template #unmaskicon>
            <IMDI icon="eye-closed"
                  @click="() => passwordinput.unmasked = !passwordinput.unmasked"
            />
        </template>
    </Password>
</template>

<script setup>
import { ref } from 'vue';
import Password from 'primevue/password';

const passwordinput = ref(null);

defineProps({
    feedback: {
        type: Boolean,
        default: true,
    },
});

const model = defineModel({
    type: String,
    default: '',
});
</script>

<style lang="scss" scoped>
.p-password svg {
    margin-top: 8px;
    margin-left: -35px;
}
</style>
